<ng-container [ngSwitch]="toolType$ | async">
  <mg-st-my-tools *ngSwitchCase="'student'"></mg-st-my-tools>
  <mg-at-my-tools *ngSwitchCase="'admin'"></mg-at-my-tools>
  <mg-tt-my-tools *ngSwitchCase="'teacher'"></mg-tt-my-tools>
</ng-container>
